import React, { useState, useRef } from 'react';
import styles from './FeedeskRegisterForm.module.css';
import { FEEDESK_API }  from '../../FeedeskConfig';
import Captcha from '../includes/Captcha';

const FeedeskRegisterForm = ({ isOpen, onClose }) => {
  const [orgName, setOrgName] = useState('');
  const [adminName, setAdminName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [businessType, setBusinessType] = useState('');
  const [address, setAddress] = useState('');
  const [orgPhone, setOrgPhone] = useState('');
  const [orgEmail, setOrgEmail] = useState('');
  const [plan, setPlan] = useState('free');

  const [loading, setLoading] = useState(false);
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaValue, setCaptchaValue] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const captchaRef = useRef(null);

  if (!isOpen) return null;

  const resetForm = () => {
    setOrgName('');
    setAdminName('');
    setEmail('');
    setPhone('');
    setBusinessType('');
    setAddress('');
    setOrgPhone('');
    setOrgEmail('');
    setPlan('free');
    setCaptchaInput('');
    setLoading(false);
    setShowSuccess(false);
    if (captchaRef.current?.refreshCaptcha) captchaRef.current.refreshCaptcha();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!adminName || !email || !orgName || !address) {
      alert('Please fill in all required fields.');
      return;
    }

    if (phone && phone.length !== 10) {
      alert('Phone number must be 10 digits.');
      return;
    }

    if (captchaInput.toLowerCase() !== captchaValue.toLowerCase()) {
      alert('Incorrect CAPTCHA. Please try again.');
      return;
    }

    setLoading(true);

    const formData = {
      admin_name: adminName,
      admin_email: email,
      admin_phone: phone,
      plan: plan,
      org_name: orgName,
      business_type: businessType,
      address: address,
      org_phone: orgPhone,
      org_email: orgEmail,
    };

    try {
      const res = await fetch(FEEDESK_API.ORG_REGISTER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('Server returned invalid response format.');
      }

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Registration failed');

      setShowSuccess(true);
    } catch (err) {
      console.error(err);
      alert(err.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showSuccess && (
        <>
          <div className={styles.overlay} onClick={() => {}} />
          <div className={styles.successModal}>
            <div className={styles.successContent}>
              <div className={styles.successIcon}>✓</div>
              <h2 className={styles.successTitle}>Registration Successful!</h2>
              <p className={styles.successMessage}>
                Credentials have been sent to your email. Please note: It may take 3-5 minutes for the email to arrive.
              </p>
              <button
                className={styles.okBtn}
                onClick={() => {
                  resetForm();
                  onClose();
                }}
              >
                OK
              </button>
            </div>
          </div>
        </>
      )}

      {!showSuccess && (
        <>
          <div className={styles.overlay} onClick={() => { if (!loading) onClose(); }} />

          <div className={styles.popup}>
            <button
              className={styles.closeBtn}
              onClick={() => { if (!loading) onClose(); }}
              disabled={loading}
            >
              ✕
            </button>

            <div className={styles.header}>
              <h3>Register your account</h3>
              <p className={styles.infoText}>A one-time password will be generated and sent to your email after registration.</p>
            </div>

            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.row}>
                <input type="text" placeholder="Full Name *" value={adminName} onChange={(e) => setAdminName(e.target.value)} required disabled={loading} />
                <input type="email" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
              </div>

              <div className={styles.row}>
                <select name="plan" value={plan} onChange={(e) => setPlan(e.target.value)} disabled={true} className={styles.selectPlan}>
                  <option value="free">Plan: Free</option>
                </select>
                  <input type="tel" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} maxLength={10} disabled={loading} />
              </div>

              <div className={styles.row}>
                <input type="text" placeholder="Organization Name *" value={orgName} onChange={(e) => setOrgName(e.target.value)} required disabled={loading} />
                <input type="text" placeholder="Business Type *" value={businessType} onChange={(e) => setBusinessType(e.target.value)} required disabled={loading} />
              </div>

              <textarea placeholder="Address *" value={address} onChange={(e) => setAddress(e.target.value)} required disabled={loading} />

              <div className={styles.row}>
                <input type="tel" placeholder="Org Phone *" value={orgPhone} onChange={(e) => setOrgPhone(e.target.value)} maxLength={10} required disabled={loading} />
                <input type="email" placeholder="Org Email *" value={orgEmail} onChange={(e) => setOrgEmail(e.target.value)} required disabled={loading} />
              </div>

              <div className={styles.captchaSection}>
                <Captcha setCaptchaValue={setCaptchaValue} ref={captchaRef} />
                <input type="text" placeholder="Enter CAPTCHA" value={captchaInput} onChange={(e) => setCaptchaInput(e.target.value)} required disabled={loading} />
              </div>

              <button type="submit" className={styles.submitBtn} disabled={loading}>
                {loading ? 'Please wait...' : 'Submit'}
              </button>
            </form>

            <div className={styles.helpText}>
              Already have an account? <a href="https://feedesk.bsparksoftwaretechnologies.com/login" target="_blank" rel="noreferrer">Sign in</a>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default FeedeskRegisterForm;
